interface CoverageGaugeProps {
  percentage: number;
  met: number;
  partial: number;
  notMet: number;
  notApplicable: number;
  total: number;
}

function getColor(pct: number): string {
  if (pct >= 70) return "#22c55e";
  if (pct >= 40) return "#eab308";
  return "#ef4444";
}

export function CoverageGauge({
  percentage,
  met,
  partial,
  notMet,
  notApplicable,
  total,
}: CoverageGaugeProps) {
  const radius = 60;
  const stroke = 10;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;
  const color = getColor(percentage);

  return (
    <div className="flex flex-col items-center gap-3">
      <svg
        width={2 * (radius + stroke)}
        height={2 * (radius + stroke)}
        className="block"
      >
        <circle
          cx={radius + stroke}
          cy={radius + stroke}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          className="text-muted"
        />
        <circle
          cx={radius + stroke}
          cy={radius + stroke}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${radius + stroke} ${radius + stroke})`}
        />
        <text
          x={radius + stroke}
          y={radius + stroke - 6}
          textAnchor="middle"
          dominantBaseline="middle"
          className="fill-foreground text-2xl font-bold"
          fontSize="28"
        >
          {Math.round(percentage)}%
        </text>
        <text
          x={radius + stroke}
          y={radius + stroke + 16}
          textAnchor="middle"
          dominantBaseline="middle"
          className="fill-muted-foreground text-xs"
          fontSize="12"
        >
          coverage
        </text>
      </svg>
      <div className="flex flex-wrap justify-center gap-2 text-xs">
        <span className="rounded bg-green-500/20 px-2 py-0.5 text-green-400">
          {met} met
        </span>
        <span className="rounded bg-yellow-500/20 px-2 py-0.5 text-yellow-400">
          {partial} partial
        </span>
        <span className="rounded bg-red-500/20 px-2 py-0.5 text-red-400">
          {notMet} not met
        </span>
        <span className="rounded bg-slate-500/20 px-2 py-0.5 text-slate-400">
          {notApplicable} n/a
        </span>
        <span className="rounded bg-muted px-2 py-0.5 text-muted-foreground">
          {total} total
        </span>
      </div>
    </div>
  );
}
